import { useState } from "react";
import "./Review.css";

const StarIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M11.5516 2.90832C11.7351 2.53673 12.2649 2.53673 12.4484 2.90832L14.9738 8.02454C15.0465 8.17197 15.1871 8.2742 15.3498 8.29798L20.9981 9.12356C21.4081 9.18348 21.5715 9.6874 21.2747 9.97648L17.1884 13.9565C17.0705 14.0714 17.0166 14.2369 17.0445 14.3992L18.0087 20.0213C18.0788 20.4298 17.65 20.7413 17.2832 20.5484L12.2327 17.8924C12.087 17.8158 11.913 17.8158 11.7673 17.8924L6.71682 20.5484C6.35 20.7413 5.92123 20.4298 5.99129 20.0213L6.95554 14.3992C6.98337 14.2369 6.92954 14.0714 6.81161 13.9565L2.72534 9.97648C2.42854 9.6874 2.59193 9.18348 3.00189 9.12356L8.65018 8.29798C8.81286 8.2742 8.95345 8.17197 9.02622 8.02455L11.5516 2.90832Z"
      fill="currentColor"
    />
  </svg>
);

function Review({ name, avatar, caption, text, photo, stars = 5, headline, setFullScreen }) {
  // local hover-only stuff if needed later
  useState(false);

  const openFullScreen = () => {
    if (!photo?.length) return;
    const product = {
      files: photo.map((item) => ({
        urls: { orig: item },
        metadata:
          photo.length === 1
            ? null
            : { extra: { pixels: { r: 255, g: 255, b: 255 } } },
      })),
    };
    setFullScreen(product);
  };

  return (
    <article className="tcard" aria-label={`Review by ${name}`}>
      <header className="tcard__header">
        <img src={avatar} alt={name} className="tcard__avatar" />
        <div className="tcard__who">
          <p className="tcard__name">{name}</p>
          {caption ? <p className="tcard__caption">{caption}</p> : null}
        </div>
      </header>

      <div className="tcard__stars" aria-hidden="true">
        {Array.from({ length: stars }).map((_, i) => (
          <StarIcon key={i} className="tcard__star" />
        ))}
      </div>

      <h3 className="tcard__headline">{(headline || "UNMATCHED OPPORTUNITIES").toUpperCase()}</h3>

      <p className="tcard__text">{text}</p>

      {photo?.length ? (
        <div className="tcard__photos" onClick={openFullScreen}>
          {photo.map((p, i) => (
            <img src={p} alt="" key={i} className="tcard__photo" />
          ))}
        </div>
      ) : null}
    </article>
  );
}

export default Review;
